// extracted by mini-css-extract-plugin
export default {"infoList":"AnimeInfo_infoList__3tUZB"};